import axios, {} from "axios";
import cookie from "react-cookies";
import AUTH from "../../constants/Auth";
import { axiosErrorHandler } from "../../swzutils";
import { changeAuthenticated, changeEnvName } from "../../store/slice/auth";
import { watchGettingStartedIntro } from "../../store/slice/settings";
const processLogin = (response, onComplete, rememberMe, username) => {
    if (response.status === 250) { // MFA Required
        onComplete(null, null, true);
    }
    else {
        const loginResponse = response.data;
        sessionStorage.clear();
        const sessionExpiry = new Date(loginResponse.session.expiresAt);
        cookie.save(AUTH.envNameCookieName, loginResponse.session.envName, { "expires": sessionExpiry });
        cookie.save(AUTH.userAuthCookieName, "1", { "expires": sessionExpiry });
        if (rememberMe && username) {
            cookie.save(AUTH.rememberMeCookieName, username, { maxAge: 31536000 /* approx 1 year in seconds */ });
        }
        else {
            cookie.remove(AUTH.rememberMeCookieName);
        }
        // Use a cookie to track if the user has setup 2FA so they cannot bypass using a new tab or by changing the url
        if (loginResponse.shouldSetup2FA) {
            cookie.save(AUTH.shouldSetup2FACookieName, "1", { "expires": sessionExpiry });
        }
        else {
            cookie.remove(AUTH.shouldSetup2FACookieName);
        }
        onComplete(loginResponse, null, false);
    }
};
function processError(error, onComplete) {
    if (error.response && error.response.status === 401) {
        onComplete(null, "Incorrect username or password.", false);
    }
    else {
        axiosErrorHandler(error, errorMessage => {
            onComplete(null, errorMessage, false);
        });
    }
}
export const performPasskeyLogin = (options, result, onComplete) => {
    axios.post('/admin/v1/authentication/passkey', {
        challenge: options.challenge,
        credential: result
    }).then(response => {
        processLogin(response, onComplete, null, null);
    }).catch((error) => {
        processError(error, onComplete);
    });
};
export const performUsernamePasswordLogin = (username, password, oneTimePassword, rememberMe, onComplete) => {
    axios.post('/admin/v1/authentication/login', {
        username,
        password,
        oneTimePassword
    }).then(response => {
        processLogin(response, onComplete, rememberMe, username);
    }).catch((error) => {
        processError(error, onComplete);
    });
};
export function dispatchLoginResponseV6Router(loginResponse, navigate, navToUrl, dispatch) {
    dispatch(changeAuthenticated(true));
    dispatch(changeEnvName(loginResponse.session.envName));
    if (loginResponse.firstLogin) {
        dispatch(watchGettingStartedIntro(true));
    }
    if (loginResponse.shouldSetup2FA) {
        navigate('/multi-factor/setup');
    }
    else {
        navigate(navToUrl || "/");
    }
}
